import type { ReactNode } from 'react';
import type { MatrixGuideLine } from '@nest-recruit/shared';
import { MoreOptions } from '../../../components/MoreOptions';
import { toneCardClass } from '../../../components/Tone';
import { useToneArea } from '../../../components/ToneArea';
import styles from './Scorecard.module.css';

/**
 * Owner 2026-11-01 (DECISIONS-LOG "Owner feedback…" Q3 a): the job's scoring matrix, for the panel to read as what to look for.
 * It is never marked line by line; the panelist still gives one overall mark (ADR 0077). Folded, so on a phone the mark stays
 * in view.
 */
export function MatrixGuideList({ lines }: { readonly lines: readonly MatrixGuideLine[] }): ReactNode {
  const area = useToneArea();
  if (lines.length === 0) return null;
  return (
    <section className={`${styles.overall} ${toneCardClass()}`} data-tone={area.tone} aria-labelledby="matrix-guide">
      <h3 id="matrix-guide" className={styles.lineTitle}>
        What to look for
      </h3>
      <p className={styles.quiet}>The job's scoring matrix. Use it to decide your one overall mark.</p>
      <MoreOptions label={`Show the ${lines.length} ${lines.length === 1 ? 'quality' : 'qualities'}`}>
        <ul className={styles.guideList}>
          {lines.map((line) => (
            <li key={line.label}>
              <b>{line.label}</b>
              {Object.entries(line.anchors).map(([score, text]) => (
                <span key={score} className={styles.guideAnchor}>
                  {score}: {text}
                </span>
              ))}
            </li>
          ))}
        </ul>
      </MoreOptions>
    </section>
  );
}
